import React, { FC, useContext, ReactNode } from 'react';
import type { I18nInstanceType } from './types';

// eslint-disable-next-line no-undefined
const I18nContext = React.createContext<I18nContextType | undefined>(undefined);

// this type can be extended if needed
export type I18nContextType = I18nInstanceType;

export const useI18nContext = (): I18nContextType => {
  const context = useContext<I18nContextType | undefined>(I18nContext);
  if (!context) {
    throw new Error('I18nContext should be wrapped with <I18nContextProvider>');
  }
  return context;
};

export const I18nContextProvider: FC<{ i18nInstance: I18nInstanceType; children?: ReactNode }> = ({
  i18nInstance,
  children,
}) => <I18nContext.Provider value={i18nInstance}>{children}</I18nContext.Provider>;

/**
 * @deprecated Use I18nContextProvider and useI18nContext instead
 */
export default I18nContext as React.Context<I18nInstanceType>;
